var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('rxNavBar',{attrs:{"title":"文件查看"}}),_vm._l((_vm.numPages),function(item,index){return _c('div',{key:index},[_c('pdf',{ref:"pdf",refInFor:true,attrs:{"src":_vm.srcPageTo,"page":index + 1}})],1)})],2)}
var staticRenderFns = []

export { render, staticRenderFns }